// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q16g","footer":"styles_footer__10pBB"};